/* eslint-disable */
import _m0 from "protobufjs/minimal";

export const protobufPackage = "user_camera";

/**
 * This file automatically generated by skymarshal.
 * DO NOT MODIFY BY HAND!!!!
 */

export interface RecordingMode {
}

export enum RecordingMode_Enum {
  VIDEO_DEFAULT = 0,
  VIDEO_1080P_30FPS = 1,
  VIDEO_1080P_30FPS_HDR = 12,
  VIDEO_1080P_FULL_30FPS = 25,
  VIDEO_1080P_FULL_30FPS_HDR = 26,
  VIDEO_1080P_60FPS = 3,
  VIDEO_1080P_60FPS_HDR = 13,
  VIDEO_1080P_120FPS = 9,
  VIDEO_2_7K_30FPS = 14,
  VIDEO_2_7K_30FPS_HDR = 15,
  VIDEO_2_7K_60FPS = 16,
  VIDEO_2_7K_60FPS_HDR = 17,
  VIDEO_4K_24FPS = 6,
  VIDEO_4K_24FPS_HDR = 11,
  VIDEO_4K_30FPS = 2,
  VIDEO_4K_30FPS_HDR = 10,
  VIDEO_4K_48FPS = 5,
  VIDEO_4K_48FPS_HDR = 7,
  VIDEO_4K_60FPS = 4,
  VIDEO_4K_60FPS_HDR = 8,
  VIDEO_4K_FULL_30FPS = 18,
  VIDEO_4K_FULL_30FPS_HDR = 19,
  VIDEO_8K_30FPS = 20,
  VIDEO_8K_24FPS = 21,
  VIDEO_4K_120FPS = 22,
  VIDEO_4K_FULL_60FPS = 23,
  VIDEO_4K_FULL_24FPS = 24,
  VIDEO_4K_DEEP_30FPS = 27,
  VIDEO_4K_DEEP_FULL_30FPS = 28,
  VIDEO_1080P_DEEP_30FPS = 29,
  VIDEO_1080P_DEEP_FULL_30FPS = 30,
  VIDEO_1080P_24FPS = 31,
  VIDEO_1080P_FULL_24FPS = 32,
  PHOTO_DEFAULT = 100,
  PHOTO_HDR = 101,
  PHOTO_NIGHT = 102,
  PHOTO_HIGH_RES = 103,
  PHOTO_24MP = 105,
  PHOTO_32MP = 106,
  PHOTO_WITH_VIDEO_DEFAULT = 107,
  PHOTO_QBC_RAW = 104,
  VIDEO_2K_30FPS = 34,
  VIDEO_2K_30FPS_HDR = 33,
  VIDEO_2K_60FPS = 35,
  VIDEO_5K_16FPS = 36,
  PHOTO_NAV_G47 = 109,
  PHOTO_NAV_R71 = 111,
  PHOTO_NAV_HDR = 108,
  PHOTO_NAV_HIGH_RES = 110,
  VIDEO_1080P_30FPS_MFG_CAL = 37,
  UNRECOGNIZED = -1,
}

export function recordingMode_EnumFromJSON(object: any): RecordingMode_Enum {
  switch (object) {
    case 0:
    case "VIDEO_DEFAULT":
      return RecordingMode_Enum.VIDEO_DEFAULT;
    case 1:
    case "VIDEO_1080P_30FPS":
      return RecordingMode_Enum.VIDEO_1080P_30FPS;
    case 12:
    case "VIDEO_1080P_30FPS_HDR":
      return RecordingMode_Enum.VIDEO_1080P_30FPS_HDR;
    case 25:
    case "VIDEO_1080P_FULL_30FPS":
      return RecordingMode_Enum.VIDEO_1080P_FULL_30FPS;
    case 26:
    case "VIDEO_1080P_FULL_30FPS_HDR":
      return RecordingMode_Enum.VIDEO_1080P_FULL_30FPS_HDR;
    case 3:
    case "VIDEO_1080P_60FPS":
      return RecordingMode_Enum.VIDEO_1080P_60FPS;
    case 13:
    case "VIDEO_1080P_60FPS_HDR":
      return RecordingMode_Enum.VIDEO_1080P_60FPS_HDR;
    case 9:
    case "VIDEO_1080P_120FPS":
      return RecordingMode_Enum.VIDEO_1080P_120FPS;
    case 14:
    case "VIDEO_2_7K_30FPS":
      return RecordingMode_Enum.VIDEO_2_7K_30FPS;
    case 15:
    case "VIDEO_2_7K_30FPS_HDR":
      return RecordingMode_Enum.VIDEO_2_7K_30FPS_HDR;
    case 16:
    case "VIDEO_2_7K_60FPS":
      return RecordingMode_Enum.VIDEO_2_7K_60FPS;
    case 17:
    case "VIDEO_2_7K_60FPS_HDR":
      return RecordingMode_Enum.VIDEO_2_7K_60FPS_HDR;
    case 6:
    case "VIDEO_4K_24FPS":
      return RecordingMode_Enum.VIDEO_4K_24FPS;
    case 11:
    case "VIDEO_4K_24FPS_HDR":
      return RecordingMode_Enum.VIDEO_4K_24FPS_HDR;
    case 2:
    case "VIDEO_4K_30FPS":
      return RecordingMode_Enum.VIDEO_4K_30FPS;
    case 10:
    case "VIDEO_4K_30FPS_HDR":
      return RecordingMode_Enum.VIDEO_4K_30FPS_HDR;
    case 5:
    case "VIDEO_4K_48FPS":
      return RecordingMode_Enum.VIDEO_4K_48FPS;
    case 7:
    case "VIDEO_4K_48FPS_HDR":
      return RecordingMode_Enum.VIDEO_4K_48FPS_HDR;
    case 4:
    case "VIDEO_4K_60FPS":
      return RecordingMode_Enum.VIDEO_4K_60FPS;
    case 8:
    case "VIDEO_4K_60FPS_HDR":
      return RecordingMode_Enum.VIDEO_4K_60FPS_HDR;
    case 18:
    case "VIDEO_4K_FULL_30FPS":
      return RecordingMode_Enum.VIDEO_4K_FULL_30FPS;
    case 19:
    case "VIDEO_4K_FULL_30FPS_HDR":
      return RecordingMode_Enum.VIDEO_4K_FULL_30FPS_HDR;
    case 20:
    case "VIDEO_8K_30FPS":
      return RecordingMode_Enum.VIDEO_8K_30FPS;
    case 21:
    case "VIDEO_8K_24FPS":
      return RecordingMode_Enum.VIDEO_8K_24FPS;
    case 22:
    case "VIDEO_4K_120FPS":
      return RecordingMode_Enum.VIDEO_4K_120FPS;
    case 23:
    case "VIDEO_4K_FULL_60FPS":
      return RecordingMode_Enum.VIDEO_4K_FULL_60FPS;
    case 24:
    case "VIDEO_4K_FULL_24FPS":
      return RecordingMode_Enum.VIDEO_4K_FULL_24FPS;
    case 27:
    case "VIDEO_4K_DEEP_30FPS":
      return RecordingMode_Enum.VIDEO_4K_DEEP_30FPS;
    case 28:
    case "VIDEO_4K_DEEP_FULL_30FPS":
      return RecordingMode_Enum.VIDEO_4K_DEEP_FULL_30FPS;
    case 29:
    case "VIDEO_1080P_DEEP_30FPS":
      return RecordingMode_Enum.VIDEO_1080P_DEEP_30FPS;
    case 30:
    case "VIDEO_1080P_DEEP_FULL_30FPS":
      return RecordingMode_Enum.VIDEO_1080P_DEEP_FULL_30FPS;
    case 31:
    case "VIDEO_1080P_24FPS":
      return RecordingMode_Enum.VIDEO_1080P_24FPS;
    case 32:
    case "VIDEO_1080P_FULL_24FPS":
      return RecordingMode_Enum.VIDEO_1080P_FULL_24FPS;
    case 100:
    case "PHOTO_DEFAULT":
      return RecordingMode_Enum.PHOTO_DEFAULT;
    case 101:
    case "PHOTO_HDR":
      return RecordingMode_Enum.PHOTO_HDR;
    case 102:
    case "PHOTO_NIGHT":
      return RecordingMode_Enum.PHOTO_NIGHT;
    case 103:
    case "PHOTO_HIGH_RES":
      return RecordingMode_Enum.PHOTO_HIGH_RES;
    case 105:
    case "PHOTO_24MP":
      return RecordingMode_Enum.PHOTO_24MP;
    case 106:
    case "PHOTO_32MP":
      return RecordingMode_Enum.PHOTO_32MP;
    case 107:
    case "PHOTO_WITH_VIDEO_DEFAULT":
      return RecordingMode_Enum.PHOTO_WITH_VIDEO_DEFAULT;
    case 104:
    case "PHOTO_QBC_RAW":
      return RecordingMode_Enum.PHOTO_QBC_RAW;
    case 34:
    case "VIDEO_2K_30FPS":
      return RecordingMode_Enum.VIDEO_2K_30FPS;
    case 33:
    case "VIDEO_2K_30FPS_HDR":
      return RecordingMode_Enum.VIDEO_2K_30FPS_HDR;
    case 35:
    case "VIDEO_2K_60FPS":
      return RecordingMode_Enum.VIDEO_2K_60FPS;
    case 36:
    case "VIDEO_5K_16FPS":
      return RecordingMode_Enum.VIDEO_5K_16FPS;
    case 109:
    case "PHOTO_NAV_G47":
      return RecordingMode_Enum.PHOTO_NAV_G47;
    case 111:
    case "PHOTO_NAV_R71":
      return RecordingMode_Enum.PHOTO_NAV_R71;
    case 108:
    case "PHOTO_NAV_HDR":
      return RecordingMode_Enum.PHOTO_NAV_HDR;
    case 110:
    case "PHOTO_NAV_HIGH_RES":
      return RecordingMode_Enum.PHOTO_NAV_HIGH_RES;
    case 37:
    case "VIDEO_1080P_30FPS_MFG_CAL":
      return RecordingMode_Enum.VIDEO_1080P_30FPS_MFG_CAL;
    case -1:
    case "UNRECOGNIZED":
    default:
      return RecordingMode_Enum.UNRECOGNIZED;
  }
}

export function recordingMode_EnumToJSON(object: RecordingMode_Enum): string {
  switch (object) {
    case RecordingMode_Enum.VIDEO_DEFAULT:
      return "VIDEO_DEFAULT";
    case RecordingMode_Enum.VIDEO_1080P_30FPS:
      return "VIDEO_1080P_30FPS";
    case RecordingMode_Enum.VIDEO_1080P_30FPS_HDR:
      return "VIDEO_1080P_30FPS_HDR";
    case RecordingMode_Enum.VIDEO_1080P_FULL_30FPS:
      return "VIDEO_1080P_FULL_30FPS";
    case RecordingMode_Enum.VIDEO_1080P_FULL_30FPS_HDR:
      return "VIDEO_1080P_FULL_30FPS_HDR";
    case RecordingMode_Enum.VIDEO_1080P_60FPS:
      return "VIDEO_1080P_60FPS";
    case RecordingMode_Enum.VIDEO_1080P_60FPS_HDR:
      return "VIDEO_1080P_60FPS_HDR";
    case RecordingMode_Enum.VIDEO_1080P_120FPS:
      return "VIDEO_1080P_120FPS";
    case RecordingMode_Enum.VIDEO_2_7K_30FPS:
      return "VIDEO_2_7K_30FPS";
    case RecordingMode_Enum.VIDEO_2_7K_30FPS_HDR:
      return "VIDEO_2_7K_30FPS_HDR";
    case RecordingMode_Enum.VIDEO_2_7K_60FPS:
      return "VIDEO_2_7K_60FPS";
    case RecordingMode_Enum.VIDEO_2_7K_60FPS_HDR:
      return "VIDEO_2_7K_60FPS_HDR";
    case RecordingMode_Enum.VIDEO_4K_24FPS:
      return "VIDEO_4K_24FPS";
    case RecordingMode_Enum.VIDEO_4K_24FPS_HDR:
      return "VIDEO_4K_24FPS_HDR";
    case RecordingMode_Enum.VIDEO_4K_30FPS:
      return "VIDEO_4K_30FPS";
    case RecordingMode_Enum.VIDEO_4K_30FPS_HDR:
      return "VIDEO_4K_30FPS_HDR";
    case RecordingMode_Enum.VIDEO_4K_48FPS:
      return "VIDEO_4K_48FPS";
    case RecordingMode_Enum.VIDEO_4K_48FPS_HDR:
      return "VIDEO_4K_48FPS_HDR";
    case RecordingMode_Enum.VIDEO_4K_60FPS:
      return "VIDEO_4K_60FPS";
    case RecordingMode_Enum.VIDEO_4K_60FPS_HDR:
      return "VIDEO_4K_60FPS_HDR";
    case RecordingMode_Enum.VIDEO_4K_FULL_30FPS:
      return "VIDEO_4K_FULL_30FPS";
    case RecordingMode_Enum.VIDEO_4K_FULL_30FPS_HDR:
      return "VIDEO_4K_FULL_30FPS_HDR";
    case RecordingMode_Enum.VIDEO_8K_30FPS:
      return "VIDEO_8K_30FPS";
    case RecordingMode_Enum.VIDEO_8K_24FPS:
      return "VIDEO_8K_24FPS";
    case RecordingMode_Enum.VIDEO_4K_120FPS:
      return "VIDEO_4K_120FPS";
    case RecordingMode_Enum.VIDEO_4K_FULL_60FPS:
      return "VIDEO_4K_FULL_60FPS";
    case RecordingMode_Enum.VIDEO_4K_FULL_24FPS:
      return "VIDEO_4K_FULL_24FPS";
    case RecordingMode_Enum.VIDEO_4K_DEEP_30FPS:
      return "VIDEO_4K_DEEP_30FPS";
    case RecordingMode_Enum.VIDEO_4K_DEEP_FULL_30FPS:
      return "VIDEO_4K_DEEP_FULL_30FPS";
    case RecordingMode_Enum.VIDEO_1080P_DEEP_30FPS:
      return "VIDEO_1080P_DEEP_30FPS";
    case RecordingMode_Enum.VIDEO_1080P_DEEP_FULL_30FPS:
      return "VIDEO_1080P_DEEP_FULL_30FPS";
    case RecordingMode_Enum.VIDEO_1080P_24FPS:
      return "VIDEO_1080P_24FPS";
    case RecordingMode_Enum.VIDEO_1080P_FULL_24FPS:
      return "VIDEO_1080P_FULL_24FPS";
    case RecordingMode_Enum.PHOTO_DEFAULT:
      return "PHOTO_DEFAULT";
    case RecordingMode_Enum.PHOTO_HDR:
      return "PHOTO_HDR";
    case RecordingMode_Enum.PHOTO_NIGHT:
      return "PHOTO_NIGHT";
    case RecordingMode_Enum.PHOTO_HIGH_RES:
      return "PHOTO_HIGH_RES";
    case RecordingMode_Enum.PHOTO_24MP:
      return "PHOTO_24MP";
    case RecordingMode_Enum.PHOTO_32MP:
      return "PHOTO_32MP";
    case RecordingMode_Enum.PHOTO_WITH_VIDEO_DEFAULT:
      return "PHOTO_WITH_VIDEO_DEFAULT";
    case RecordingMode_Enum.PHOTO_QBC_RAW:
      return "PHOTO_QBC_RAW";
    case RecordingMode_Enum.VIDEO_2K_30FPS:
      return "VIDEO_2K_30FPS";
    case RecordingMode_Enum.VIDEO_2K_30FPS_HDR:
      return "VIDEO_2K_30FPS_HDR";
    case RecordingMode_Enum.VIDEO_2K_60FPS:
      return "VIDEO_2K_60FPS";
    case RecordingMode_Enum.VIDEO_5K_16FPS:
      return "VIDEO_5K_16FPS";
    case RecordingMode_Enum.PHOTO_NAV_G47:
      return "PHOTO_NAV_G47";
    case RecordingMode_Enum.PHOTO_NAV_R71:
      return "PHOTO_NAV_R71";
    case RecordingMode_Enum.PHOTO_NAV_HDR:
      return "PHOTO_NAV_HDR";
    case RecordingMode_Enum.PHOTO_NAV_HIGH_RES:
      return "PHOTO_NAV_HIGH_RES";
    case RecordingMode_Enum.VIDEO_1080P_30FPS_MFG_CAL:
      return "VIDEO_1080P_30FPS_MFG_CAL";
    case RecordingMode_Enum.UNRECOGNIZED:
    default:
      return "UNRECOGNIZED";
  }
}

function createBaseRecordingMode(): RecordingMode {
  return {};
}

export const RecordingMode = {
  encode(_: RecordingMode, writer: _m0.Writer = _m0.Writer.create()): _m0.Writer {
    return writer;
  },

  decode(input: _m0.Reader | Uint8Array, length?: number): RecordingMode {
    const reader = input instanceof _m0.Reader ? input : _m0.Reader.create(input);
    let end = length === undefined ? reader.len : reader.pos + length;
    const message = createBaseRecordingMode();
    while (reader.pos < end) {
      const tag = reader.uint32();
      switch (tag >>> 3) {
      }
      if ((tag & 7) === 4 || tag === 0) {
        break;
      }
      reader.skipType(tag & 7);
    }
    return message;
  },

  fromJSON(_: any): RecordingMode {
    return {};
  },

  toJSON(_: RecordingMode): unknown {
    const obj: any = {};
    return obj;
  },

  create<I extends Exact<DeepPartial<RecordingMode>, I>>(base?: I): RecordingMode {
    return RecordingMode.fromPartial(base ?? ({} as any));
  },
  fromPartial<I extends Exact<DeepPartial<RecordingMode>, I>>(_: I): RecordingMode {
    const message = createBaseRecordingMode();
    return message;
  },
};

type Builtin = Date | Function | Uint8Array | string | number | boolean | undefined;

export type DeepPartial<T> = T extends Builtin ? T
  : T extends globalThis.Array<infer U> ? globalThis.Array<DeepPartial<U>>
  : T extends ReadonlyArray<infer U> ? ReadonlyArray<DeepPartial<U>>
  : T extends {} ? { [K in keyof T]?: DeepPartial<T[K]> }
  : Partial<T>;

type KeysOfUnion<T> = T extends T ? keyof T : never;
export type Exact<P, I extends P> = P extends Builtin ? P
  : P & { [K in keyof P]: Exact<P[K], I[K]> } & { [K in Exclude<keyof I, KeysOfUnion<P>>]: never };
